import React, { useMemo } from 'react';
import './VListTree.scss';
import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import CaretRightOutlined from '@ant-design/icons/CaretRightOutlined';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
const defaultOffsetBlock = React.createElement("div", { style: { width: 8, flexShrink: 0 } });
const VListTreeCard = props => {
    const { data, expand, deep = 0, active, onRightClick, onClick, onExpand, titleRender, showExpand, isLoading = false, icon, calssName } = props;
    const _titleRender = useMemo(() => {
        return typeof (data === null || data === void 0 ? void 0 : data.title) == 'function' ? data === null || data === void 0 ? void 0 : data.title : titleRender;
    }, [data, titleRender]);
    const title = useMemo(() => {
        return data === null || data === void 0 ? void 0 : data.title;
    }, [data]);
    const handleExpand = (event) => {
        event.stopPropagation();
        onExpand && onExpand(!expand);
    };
    const handleRightClick = (event) => {
        event.persist();
        event.preventDefault();
        onRightClick && onRightClick(event, data);
    };
    const handleClick = (event) => {
        event.persist();
        onClick && onClick(event, data);
    };
    const OffsetElement = useMemo(() => {
        let list = [];
        list.length = deep ? deep - 1 : 0;
        list.fill(defaultOffsetBlock);
        return list;
    }, [deep]);
    const ExpandElement = useMemo(() => {
        const expandIcon = expand ? React.createElement(CaretDownOutlined, { className: "VLExpand-icon" }) : React.createElement(CaretRightOutlined, { className: "VLExpand-icon" });
        return showExpand ? (React.createElement("div", { className: "VLExpand-wrap", onClick: e => {
                !isLoading && handleExpand(e);
            } }, isLoading ? React.createElement(LoadingOutlined, { style: { fontSize: '12px', color: '#84868d' } }) : expandIcon)) : (React.createElement("div", { style: { width: 25, flexShrink: 0 } }));
    }, [data]);
    const IconElement = useMemo(() => {
        return (data === null || data === void 0 ? void 0 : data.icon) || icon ? (React.createElement("div", { className: "VListTreeCard-icon", onClick: handleExpand }, icon ? icon : data === null || data === void 0 ? void 0 : data.icon)) : (React.createElement(React.Fragment, null));
    }, [data, icon]);
    return (React.createElement("div", { className: `VListTreeCard-Wrap ${active ? 'active' : ''} ${calssName || ''}`, onContextMenu: handleRightClick, onClick: handleClick },
        OffsetElement,
        ExpandElement,
        IconElement,
        _titleRender ? _titleRender(data) : React.createElement("div", { className: "vlist-tree-title-wrap" }, title)));
};
export default VListTreeCard;
